import React from "react";
import PageHeader from "../../Components/PageHeader";
import LoadingSpinner from "../../Components/LoadingSpinner";
import { useBookingReports } from "./hooks/useBookingReports";
import ReportFilters from "./components/ReportFilters";
import SummaryCards from "./components/SummaryCards";
import ReportCharts from "./components/ReportCharts";
import DetailedBookingsTable from "./components/DetailedBookingsTable";

const BookingReportsPage = () => {
  const {
    loading,
    reportData,
    detailedBookings,
    pagination,
    doctors,
    departments,
    branches, // Add branches
    userRole, // Add userRole
    filters,
    handleFilterChange,
    handleApplyFilters,
    handleResetFilters,
    exportToCSV,
    fetchDetailedBookings,
  } = useBookingReports();

  if (loading && !reportData) {
    return (
      <LoadingSpinner
        size="xl"
        text="Loading reports..."
        fullScreen={true}
        color="blue"
      />
    );
  }

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <PageHeader
        title="Booking Reports & Analytics"
        subtitle="Comprehensive booking statistics and insights"
      />

      {/* Filters Section */}
      <ReportFilters
        filters={filters}
        onFilterChange={handleFilterChange}
        onApplyFilters={handleApplyFilters}
        onResetFilters={handleResetFilters}
        onExportCSV={exportToCSV}
        doctors={doctors}
        departments={departments}
        branches={branches} // Pass branches
        userRole={userRole} // Pass userRole
      />

      {/* Display report data if available */}
      {reportData && (
        <>
          {/* Summary Cards */}
          <SummaryCards reportData={reportData} />

          {/* Charts Section */}
          <ReportCharts reportData={reportData} />

          {/* Detailed Bookings Table */}
          <DetailedBookingsTable
            detailedBookings={detailedBookings}
            pagination={pagination}
            onPageChange={fetchDetailedBookings}
          />
        </>
      )}
    </div>
  );
};

export default BookingReportsPage;
